import get from "lodash/get";

const getAuthentication = state => state.authentication;
const getToken = state => get(getAuthentication(state), "token");
const getDecodedToken = state => get(getAuthentication(state), "decodedToken");

export { getToken, getDecodedToken };
